import type { AppStartListening } from "types/AppStartListening";

import { dataApi } from "services/streamingApi/data.api";

import { sitesThunks } from "features/sites/store/slice";

export const addDevicesListeners = (startListening: AppStartListening) => {
    // preload devices on site selection
    startListening({
        actionCreator: sitesThunks.fetchSelectedSiteSearchResultAsync.fulfilled,
        effect: async (action, listenerApi) => {
            const payload = {
                siteId: action.meta.arg.id,
                category: "video", // todo should we make this configurable or something?
            };

            listenerApi.dispatch(
                dataApi.util.prefetch(
                    "getDevicesBySiteAndCategory",
                    payload,
                    {},
                ),
            );
        },
    });
};
